import { trackInviteeBookedV3 } from 'features/contacts'

export const trackBookModalInviteeBooked = ({
  userUuid,
  inviteeUuid,
  eventUuid,
  eventTypeUuid,
  source,
  bookingType,
  view,
}) => {
  const isReschedule = bookingType === 'reschedule'
  const isFullCalendar = view === 'full_calendar'

  let bookingMethod
  if (isFullCalendar) {
    bookingMethod = 'override_available_times'
  } else if (isReschedule) {
    bookingMethod = 'reschedule_available_times'
  }

  trackInviteeBookedV3({
    user_uuid: userUuid,
    invitee_uuid: inviteeUuid,
    event_uuid: eventUuid,
    event_type_uuid: eventTypeUuid,
  }, source, {
    isReschedule,
    isOverrideAvailableTimes: isFullCalendar,
    location: isFullCalendar ? 'full_calendar' : 'available_times',
    userAction: isReschedule ? 'rescheduling' : 'book_on_behalf',
    bookingMethod,
  })
}

export const trackPublisherRescheduleInviteeBooked = ({
  userUuid,
  inviteeUuid,
  eventUuid,
  eventTypeUuid,
  source,
  view,
}) => {
  const isOverrideReschedule = view === 'full_calendar'
  trackInviteeBookedV3({
    user_uuid: userUuid,
    invitee_uuid: inviteeUuid,
    event_uuid: eventUuid,
    event_type_uuid: eventTypeUuid,
  }, source, {
    isReschedule: true,
    isOverrideAvailableTimes: isOverrideReschedule,
    location: isOverrideReschedule ? 'full_calendar' : 'available_times',
    userAction: 'rescheduling',
    bookingMethod: isOverrideReschedule ? 'override_available_times' : 'reschedule_available_times',
  })
}
